import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logic",
  "use": "icon-logic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-logic\"><path fill=\"#707070\" d=\"M800 800h-640A32 32 0 0 1 128 768V128a32 32 0 0 1 64 0v608h608a32 32 0 0 1 0 64z\" /><path fill=\"#707070\" d=\"M672 992a30.08 30.08 0 0 1-22.4-9.6 30.72 30.72 0 0 1 0-44.8L818.56 768l-168.96-169.6a31.36 31.36 0 0 1 44.8-44.8l192 192a30.72 30.72 0 0 1 0 44.8l-192 192a30.08 30.08 0 0 1-22.4 9.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logic.svg
// module id = wItA
// module chunks = 55